import * as NoteField from '../note/field';

import { BaseItem } from '../common';

export enum Source {
  Analyst = 'ANALYST',
  Predict = 'PREDICT',
}

export enum Command {
  ApplyNoteMacro = 'APPLY_NOTE_MACRO',
  ApplyNoteTemplate = 'APPLY_NOTE_TEMPLATE',
  CarryCurrent = 'CARRY_CURRENT',
  CarryForward = 'CARRY_FORWARD',
  DeleteNoteTemplateField = 'DELETE_NOTE_TEMPLATE_FIELD',
  DeleteText = 'DELETE_TEXT',
  MarkAllAsReviewed = 'MARK_ALL_AS_REVIEWED',
  RosAsInHpi = 'ROS_AS_IN_HPI',
  SaveEmCode = 'SAVE_EM_CODE',
  SubstituteText = 'SUBSTITUTE_TEXT',
  SetInpatientNoteType = 'SET_INPATIENT_NOTE_TYPE',
}

export enum InpatientNoteType {
  HistoryAndPhysical = 'HISTORY_AND_PHYSICAL',
  ProgressNote = 'PROGRESS_NOTE',
  DischargeSummary = 'DISCHARGE_SUMMARY',
  Consult = 'CONSULT',
}

export interface BaseValues {
  noteTranscriptSegmentId: string;
  command: Command;
  source: Source;
}

export interface ApplyNoteMacroCreate extends BaseValues {
  command: Command.ApplyNoteMacro;
  noteMacroId: string;
}
export interface ApplyNoteMacro
  extends BaseItem,
    ApplyNoteMacroCreate,
    DeleteValues {}

export interface ApplyNoteTemplateCreate extends BaseValues {
  command: Command.ApplyNoteTemplate;
  noteTemplateId: string;
}
export interface ApplyNoteTemplate
  extends BaseItem,
    ApplyNoteTemplateCreate,
    DeleteValues {}

export interface CarryCurrentCreate extends BaseValues {
  command: Command.CarryCurrent;
  noteFieldSection: NoteField.Section;
}
export interface CarryCurrent
  extends BaseItem,
    CarryCurrentCreate,
    DeleteValues {}

export interface CarryForwardCreate extends BaseValues {
  command: Command.CarryForward;
  noteFieldSection: NoteField.Section;
}
export interface CarryForward
  extends BaseItem,
    CarryForwardCreate,
    DeleteValues {}

export interface DeleteNoteTemplateFieldCreate extends BaseValues {
  command: Command.DeleteNoteTemplateField;
  noteFieldSection: NoteField.Section;
  noteFieldSubsection?: string;
  noteFieldName: string;
}
export interface DeleteNoteTemplateField
  extends BaseItem,
    DeleteNoteTemplateFieldCreate,
    DeleteValues {}

export interface DeleteTextCreate extends BaseValues {
  command: Command.DeleteText;
}
export interface DeleteText extends BaseItem, DeleteTextCreate, DeleteValues {}

export interface RosAsInHpiCreate extends BaseValues {
  command: Command.RosAsInHpi;
}
export interface RosAsInHpi extends BaseItem, RosAsInHpiCreate, DeleteValues {}

export interface SubstituteTextCreate extends BaseValues {
  command: Command.SubstituteText;
  substituteText: string;
}
export interface SubstituteText
  extends BaseItem,
    SubstituteTextCreate,
    DeleteValues {}

export interface MarkAllAsReviewedCreate extends BaseValues {
  command: Command.MarkAllAsReviewed;
}
export interface MarkAllAsReviewed
  extends BaseItem,
    MarkAllAsReviewedCreate,
    DeleteValues {}
export interface SaveEmCodeCreate extends BaseValues {
  command: Command.SaveEmCode;
  emCode: string;
}
export interface SaveEmCode extends BaseItem, SaveEmCodeCreate, DeleteValues {}

export interface SetInpatientNoteTypeCreate extends BaseValues {
  command: Command.SetInpatientNoteType;
  inpatientNoteType: InpatientNoteType;
}
export interface SetInpatientNoteType
  extends BaseItem,
    SetInpatientNoteTypeCreate,
    DeleteValues {}

export type CreateValues =
  | ApplyNoteMacroCreate
  | ApplyNoteTemplateCreate
  | CarryCurrentCreate
  | CarryForwardCreate
  | DeleteNoteTemplateFieldCreate
  | DeleteTextCreate
  | RosAsInHpiCreate
  | SubstituteTextCreate
  | MarkAllAsReviewedCreate
  | SaveEmCodeCreate
  | SetInpatientNoteTypeCreate;

export interface DeleteValues {
  isDeleted: boolean;
  deletedTimestamp: Date | null;
}

interface CommandValues {
  noteMacroId: string | null;
  noteTemplateId: string | null;
  noteFieldSection: NoteField.Section | null;
  noteFieldSubsection: string | null;
  noteFieldName: string | null;
  substituteText: string | null;
  emCode: string | null;
  inpatientNoteType: InpatientNoteType | null;
}

export type UpdateValues = Partial<BaseValues & CommandValues & DeleteValues>;

export interface NoteTranscriptCommand
  extends BaseItem,
    BaseValues,
    CommandValues,
    DeleteValues {}
